<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="550px"
    :before-close="handleClose"
    custom-class="subscribe-dialog"
    :close-on-click-modal="false"
  >
    <!-- 头部产品信息 -->
    <div class="dialog-header">
      <div class="product-logo">
        <img
          v-if="productInfo.typeItem && productInfo.typeItem.icon"
          :src="productInfo.typeItem.icon"
        />
        <span v-else class="logo-placeholder">SP</span>
      </div>
      <div class="product-info">
        <h3 class="product-name">{{ productInfo.typeItem?.type || productInfo.typeItem?.familyCode }}</h3>
        <p class="product-subtitle">
          {{ productInfo.typeItem?.name }}
          <!-- <el-tag
            v-if="isFree"
            type="success"
            size="mini"
            style="margin-left: 8px"
          >
            {{ $t("SubscribeDialog.freeTrial") || "免费试用" }}
          </el-tag> -->
        </p>
      </div>
    </div>

    <!-- 时长单位选择 -->
    <div class="duration-section" :class="{ disabled: isFree }">
      <h4 class="section-title">{{ $t("SubscribeDialog.durationUnit") }}</h4>
      <div class="duration-tabs">
        <div
          v-for="item in durationOptions"
          :key="item.value"
          class="duration-tab"
          :class="{
            active: selectedDuration === item.value,
            disabled: isFree,
          }"
          @click="!isFree && selectDuration(item.value)"
        >
          <span class="duration-label">{{ item.label }}</span>
          <span v-if="item.recommend && !isFree" class="recommend-tag">{{
            $t("SubscribeDialog.recommend")
          }}</span>
        </div>
      </div>

      <!-- 滑块 -->
      <div class="duration-slider">
        <el-slider
          v-model="sliderValue"
          :min="0"
          :max="3"
          :step="1"
          :show-tooltip="false"
          :disabled="isFree"
          @input="handleSliderInput"
        />
      </div>

      <!-- 价格展示 -->
      <div class="price-display" v-if="!isFree">
        <div
          v-for="item in computedDurationOptions"
          :key="item.value"
          class="price-item"
          :class="{ active: selectedDuration === item.value }"
        >
          <span class="price-label">{{ $t("SubscribeDialog.only") }}</span>
          <span class="price-value"
            >{{ item.pricePerDay }}{{ $t("SubscribeDialog.perDay") }}</span
          >
        </div>
      </div>
      <!-- <div class="free-trial-tip" v-else>
        <i class="el-icon-info"></i>
        <span>{{
          $t("SubscribeDialog.freeTrialTip") || "免费试用版，时长和数量固定为1"
        }}</span>
      </div> -->
    </div>

    <!-- 订阅时长 -->
    <div class="input-section" :class="{ disabled: isFree }">
      <span class="input-label">{{
        $t("SubscribeDialog.subscribeDuration")
      }}</span>
      <div class="input-control">
        <el-button
          icon="el-icon-minus"
          class="quantity-btn"
          size="small"
          :disabled="isFree || subscribeTime <= 1"
          @click="decreaseTime"
        />
        <el-input-number
          v-model="subscribeTime"
          :min="1"
          :max="99"
          :controls="false"
          size="small"
          :disabled="isFree"
          @change="handleTimeChange"
        />
        <el-button
          icon="el-icon-plus"
          class="quantity-btn"
          size="small"
          :disabled="isFree || subscribeTime >= 99"
          @click="increaseTime"
        />
      </div>
    </div>

    <!-- 软件数量 -->
    <div class="input-section" :class="{ disabled: isFree }">
      <span class="input-label">{{
        $t("SubscribeDialog.softwareQuantity")
      }}</span>
      <div class="input-control">
        <el-button
          class="quantity-btn"
          icon="el-icon-minus"
          size="small"
          :disabled="isFree || softwareQuantity <= 1"
          @click="decreaseQuantity"
        />
        <el-input-number
          v-model="softwareQuantity"
          :min="1"
          :max="99"
          :controls="false"
          size="small"
          :disabled="isFree"
        />
        <el-button
          class="quantity-btn"
          icon="el-icon-plus"
          size="small"
          :disabled="isFree || softwareQuantity >= 99"
          @click="increaseQuantity"
        />
      </div>
    </div>

    <!-- 合计 -->
    <div class="total-section">
      <span class="total-label">{{ $t("SubscribeDialog.total") }}</span>
      <span class="total-price">
        {{ isFree ? "¥ 0" : `¥ ${totalPrice}` }}
      </span>
    </div>

    <!-- 底部操作 -->
    <div class="dialog-footer">
      <div v-if="!isFree" class="cart-btn" @click="addToCart">
        <img src="@/assets/image/pay/shoppingCart.png" class="cart-btn-icon" alt="cart" />
      </div>
      <el-button
        type="primary"
        class="subscribe-btn"
        :class="{ 'full-width': isFree }"
        @click="handleSubscribe"
      >
        {{ $t("SubscribeDialog.subscribeNow") }}
      </el-button>
    </div>

    <!-- 协议 -->
    <div class="agreement-section">
      <el-checkbox v-model="agreedTerms" size="small" @change="handleAgreeChange" />
      <span class="agreement-text">
        {{ $t("SubscribeDialog.agreementText") }}
        <a href="#" @click.prevent="openAgreement('product')">{{
          $t("SubscribeDialog.productAgreement")
        }}</a>
        <a href="#" @click.prevent="openAgreement('license')">{{
          $t("SubscribeDialog.licenseAgreement")
        }}</a>
      </span>
    </div>

    <!-- 协议内容弹框 -->
    <el-dialog
      :visible.sync="agreementDialogVisible"
      width="800px"
      append-to-body
      custom-class="agreement-dialog"
    >
      <div
        class="agreement-content"
        v-html="currentAgreement.content"
        @scroll.passive="handleAgreementScroll"
      />
      <span slot="footer">
        <el-button
          type="primary"
          :disabled="!readButtonVisible"
          v-show="readButtonVisible"
          @click="confirmAgreement"
          >{{ $t("SubscribeDialog.haveRead") }}</el-button
        >
        <el-button type="primary" v-show="!readButtonVisible" disabled>
          {{ $t("SubscribeDialog.scrollToAgree") }}
        </el-button>
      </span>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { System_article } from "@/assets/API/service";
export default {
  name: "SubscribeDialog",

  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    productInfo: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      selectedDuration: "week",
      sliderValue: 0,
      subscribeTime: 1,
      softwareQuantity: 1,
      agreedTerms: false,
      readAgreement: false, // 是否已完整阅读协议（强制先阅读才能勾选）
      agreementDialogVisible: false,
      systemArticles: [],
      productNotices: [], // 当前产品对应的订阅须知（code=notice, product=当前产品id）
      agreementHtml: "",
      readButtonVisible: false,
    };
  },

  computed: {
    isFree() {
      return this.productInfo.isFree === true || this.productInfo.type == 0;
    },

    language() {
      return this.$i18n.locale;
    },

    dialogVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit("update:visible", val);
      },
    },
    durationConfig() {
      return [
        {
          label: this.$t("SubscribeDialog.week"),
          value: "week",
          days: 7,
          recommend: false,
          convertThreshold: 4,
          nextUnit: "month",
          priceField: "weekprice",
        },
        {
          label: this.$t("SubscribeDialog.month"),
          value: "month",
          days: 30,
          recommend: true,
          convertThreshold: 3,
          nextUnit: "quarter",
          priceField: "monthprice",
        },
        {
          label: this.$t("SubscribeDialog.quarter"),
          value: "quarter",
          days: 90,
          recommend: false,
          convertThreshold: 2,
          nextUnit: "halfyear",
          priceField: "seasonprice",
        },
        {
          label: this.$t("SubscribeDialog.halfyear"),
          value: "halfyear",
          days: 182,
          recommend: false,
          convertThreshold: null,
          nextUnit: null,
          priceField: "halfyearprice",
        },
      ];
    },

    // 根据接口数据计算每个时长的价格
    computedDurationOptions() {
      return this.durationConfig.map((config) => {
        let totalPrice = 0;

        switch (config.value) {
          case "week":
            totalPrice = this.productInfo.weekprice || 0;
            break;
          case "month":
            totalPrice = this.productInfo.monthprice || 0;
            break;
          case "quarter":
            totalPrice = this.productInfo.seasonprice || 0;
            break;
          case "halfyear":
            totalPrice = (this.productInfo.halfyearprice || 0);
            break;
        }

        const pricePerDay =
          config.days > 0 ? parseInt(totalPrice / config.days) : 0;

        return {
          ...config,
          totalPrice,
          pricePerDay: parseFloat(pricePerDay),
        };
      });
    },

    durationOptions() {
      return this.computedDurationOptions;
    },

    currentDurationOption() {
      return (
        this.computedDurationOptions.find(
          (item) => item.value === this.selectedDuration
        ) || this.computedDurationOptions[1]
      );
    },

    totalPrice() {
      if (this.isFree) return "0.00";
      const { totalPrice } = this.currentDurationOption;
      return (totalPrice * this.subscribeTime * this.softwareQuantity).toFixed(
        2
      );
    },

    currentAgreement() {
      return {
        title: "用户协议",
        content: this.agreementHtml,
      };
    },
  },

  watch: {
    visible(val) {
      if (val) {
        console.log(this.productInfo);

        this.selectedDuration = "week";
        this.sliderValue = 0;
        this.subscribeTime = 1;
        this.softwareQuantity = 1;
        this.agreedTerms = false;
        this.readAgreement = false; // 每次打开订阅弹框都需重新阅读协议
        this.loadProductNotices();
      }
    },
  },

  async mounted() {
    await this.loadSystemArticles();
  },

  methods: {
    selectDuration(value) {
      if (this.isFree) return;
      this.selectedDuration = value;
      const index = this.durationConfig.findIndex(
        (item) => item.value === value
      );
      this.sliderValue = index;
      this.subscribeTime = 1;
    },

    handleSliderInput(val) {
      if (this.isFree) return;
      this.selectedDuration = this.durationConfig[val].value;
      this.subscribeTime = 1;
    },

    handleTimeChange(val) {
      if (val && val >= 1) {
        this.$nextTick(() => {
          this.convertToOptimalUnit();
        });
      }
    },

    convertToOptimalUnit() {
      let currentIndex = this.sliderValue;
      let currentTime = this.subscribeTime;

      const result = this.calculateOptimalUnit(currentIndex, currentTime);

      if (result.index !== currentIndex || result.time !== currentTime) {
        this.sliderValue = result.index;
        this.selectedDuration = this.durationConfig[result.index].value;
        this.subscribeTime = result.time;
      }
    },

    calculateOptimalUnit(unitIndex, time) {
      const option = this.durationConfig[unitIndex];

      if (
        !option.convertThreshold ||
        !option.nextUnit ||
        time < option.convertThreshold
      ) {
        return { index: unitIndex, time: time };
      }

      const convertedTime = Math.floor(time / option.convertThreshold);
      const remainder = time % option.convertThreshold;

      if (remainder !== 0) {
        return { index: unitIndex, time: time };
      }

      const nextIndex = this.durationConfig.findIndex(
        (item) => item.value === option.nextUnit
      );

      if (nextIndex === -1) {
        return { index: unitIndex, time: time };
      }

      return this.calculateOptimalUnit(nextIndex, convertedTime);
    },

    decreaseTime() {
      if (this.subscribeTime > 1) {
        this.subscribeTime--;
      }
    },

    increaseTime() {
      if (this.subscribeTime < 99) {
        this.subscribeTime++;
        this.$nextTick(() => {
          this.convertToOptimalUnit();
        });
      }
    },

    decreaseQuantity() {
      if (this.softwareQuantity > 1) {
        this.softwareQuantity--;
      }
    },

    increaseQuantity() {
      if (this.softwareQuantity < 99) {
        this.softwareQuantity++;
      }
    },

    addToCart() {
      this.dialogVisible = false;
      this.$emit("add-cart", {
        productInfo: this.productInfo,
        duration: this.subscribeTime,
        durationunion: this.selectedDuration,
        quantity: this.softwareQuantity,
        totalPrice: parseFloat(this.totalPrice),
      });
    },

    handleSubscribe() {
      if (!this.agreedTerms) {
        this.$message.warning(this.$t("SubscribeDialog.pleaseAgreeFirst"));
        return;
      }

      this.dialogVisible = false;

      this.$emit("subscribe", {
        productInfo: this.productInfo,
        duration:  this.isFree ? 1 : this.subscribeTime, // 免费试用固定为1
        durationunion: this.isFree ? "week" : this.selectedDuration,
        quantity: this.isFree ? 1 : this.softwareQuantity, // 免费试用固定为1
        totalPrice: this.isFree ? 0 : parseFloat(this.totalPrice),
        isFree: this.isFree,
      });
    },

    async loadSystemArticles() {
      try {
        const res = await System_article();
        const list = res?.data?.list || res?.data || [];
        this.systemArticles = Array.isArray(list) ? list : [];
      } catch (error) {
        console.warn("获取系统协议失败", error);
        this.systemArticles = [];
      }
    },

    // 按当前购买产品+版本查询对应的产品订阅须知（code=notice, product=当前产品id）
    // 版本：0免费版/1线上版(订阅)/2线下版/99定制版；后台未配置对应版本时回退到通用(无版本)须知
    async loadProductNotices() {
      this.productNotices = [];
      const productId =
        this.productInfo?.typeItem?.id ||
        this.productInfo?.productId ||
        this.productInfo?.id;
      // 当前购买的版本（免费试用=0，其余取定价方案的 type）
      const version = this.isFree
        ? "0"
        : this.productInfo?.type != null && this.productInfo?.type !== ""
        ? String(this.productInfo.type)
        : "";
      const fetchNotices = async (params) => {
        const res = await System_article({
          currentPage: 1,
          pageSize: 50,
          code: "notice",
          product: productId ? String(productId) : "",
          ...params,
        });
        const list = res?.data?.list || res?.data || [];
        return Array.isArray(list) ? list : [];
      };
      try {
        let list = await fetchNotices(version ? { version } : {});
        // 对应版本没配置时，回退查询不限版本的须知（取通用或该产品其它配置）
        if (version && list.length === 0) {
          list = await fetchNotices({});
        }
        // 兜底过滤：优先当前产品，其次未指定产品（全局）
        list = list.filter(
          (item) =>
            item.code === "notice" &&
            (!item.product || !productId || String(item.product) === String(productId))
        );
        // 排序：精确匹配当前版本的优先，其次通用(无版本)，最后其它
        const exact = list.filter(
          (item) => version && String(item.version || "") === version
        );
        const generic = list.filter((item) => !item.version);
        this.productNotices = exact.length
          ? exact
          : generic.length
          ? generic
          : list;
      } catch (error) {
        console.warn("获取产品订阅须知失败", error);
        this.productNotices = [];
      }
    },

    // 许可协议保持不变：从已加载的文章中取第一条 license 文章（兼容旧数据取第二条）
    getLicenseArticle() {
      const list = this.systemArticles.filter((item) => item.code === "license");
      return list.length ? list[0] : this.systemArticles[1] || null;
    },

    openAgreement() {
      const isZh = this.language === "zh";
      const getText = (item) => ({
        title: isZh ? item.title : item.titleen,
        content: isZh ? item.content : item.contenten,
      });

      // 产品订阅须知（按产品查询）
      const notice = this.productNotices.length ? this.productNotices[0] : null;
      // 许可协议（保持不变）
      const license = this.getLicenseArticle();

      const noticeData = notice ? getText(notice) : null;
      const licenseData = license ? getText(license) : null;

      const productSection = noticeData
        ? `
        <section class="agreement-block">
          <h3>《${noticeData.title}》</h3>
          ${noticeData.content}
        </section>
      `
        : `
        <section class="agreement-block">
          <h3>《产品订阅须知》</h3>
          <p>该产品暂未配置订阅须知</p>
        </section>
      `;

      const licenseSection = licenseData
        ? `
        <section class="agreement-block">
          <h3>《${licenseData.title}》</h3>
          ${licenseData.content}
        </section>
      `
        : "";

      this.agreementHtml = `${productSection}${licenseSection}`;

      this.readButtonVisible = false;
      this.agreementDialogVisible = true;

      this.$nextTick(() => {
        // 弹框设置了 append-to-body，渲染在 body 下而非组件 $el 内，需从 document 查找
        const el = document.querySelector(".agreement-content");
        if (!el) return;
        el.scrollTop = 0;
        this.checkAgreementScrollable(el);
        // 协议中的图片加载完成后内容高度可能变化，需重新判断是否出现滚动条
        el.querySelectorAll("img").forEach((img) => {
          if (!img.complete) {
            img.addEventListener(
              "load",
              () => this.checkAgreementScrollable(el),
              { once: true }
            );
          }
        });
      });
    },

    // 内容一屏即可显示完（无滚动条）时，无需滚动直接允许同意
    checkAgreementScrollable(el) {
      if (el.scrollHeight <= el.clientHeight + 10) {
        this.readButtonVisible = true;
      }
    },

    handleAgreementScroll(e) {
      const target = e.target;
      const atBottom =
        target.scrollTop + target.clientHeight >= target.scrollHeight - 10;
      this.readButtonVisible = atBottom;
    },

    // 勾选协议：未阅读过协议时阻止勾选并强制打开协议阅读
    handleAgreeChange(val) {
      if (val) {
        if (!this.readAgreement) {
          this.$nextTick(() => {
            this.agreedTerms = false;
          });
          this.openAgreement();
          return;
        }
        this.agreedTerms = true;
      } else {
        this.agreedTerms = false;
      }
    },

    // 协议弹框“已阅读”：标记已阅读并自动勾选协议
    confirmAgreement() {
      this.readAgreement = true;
      this.agreedTerms = true;
      this.agreementDialogVisible = false;
    },

    handleClose() {
      this.dialogVisible = false;
    },
  },
};
</script>
<style lang="scss">
.el-dialog {
  pointer-events: auto;
}

.subscribe-dialog .el-dialog__header {
  padding: 0 !important;
}
.dialog-header {
  display: flex;
  align-items: center;
  padding-bottom: 20px;

  .product-logo {
    width: 56px;
    height: 56px;
    border-radius: 12px;
    background: linear-gradient(135deg, #1e88e5, #1565c0);
    display: flex;
    align-items: center;
    justify-content: center;
    margin-right: 16px;

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      border-radius: 12px;
    }

    .logo-placeholder {
      color: #fff;
      font-size: 24px;
      font-weight: bold;
    }
  }

  .product-info {
    .product-name {
      margin: 0 0 4px;
      font-size: 18px;
      color: #333;
    }

    .product-subtitle {
      margin: 0;
      font-size: 14px;
    }
  }
}

.duration-section {
  background-color: #f8f9fa;
  padding: 20px;

  .section-title {
    margin: 0 0 16px;
    font-size: 16px;
    color: #333;
  }

  .duration-tabs {
    display: flex;
    justify-content: space-between;
    margin-bottom: 8px;

    .duration-tab {
      position: relative;
      padding: 8px 16px;
      cursor: pointer;
      color: #666;
      font-size: 14px;

      &.active {
        font-weight: 500;
      }

      .recommend-tag {
        position: absolute;
        top: -8px;
        right: -8px;
        padding: 2px 6px;
        background: #ff5404;
        color: #fff;
        font-size: 10px;
        border-radius: 4px 4px 4px 0;
      }
    }
  }

  .duration-slider {
    padding: 0 10px;

    ::v-deep .el-slider__runway {
      height: 4px;
      background: #e0e0e0;
    }

    ::v-deep .el-slider__bar {
      height: 4px;
      background: #1e88e5;
    }

    ::v-deep .el-slider__button {
      width: 16px;
      height: 16px;
      border: 2px solid #1e88e5;
    }
  }

  .price-display {
    display: flex;
    justify-content: space-between;
    margin-top: 12px;

    .price-item {
      text-align: center;

      .price-label {
        display: block;
        font-size: 12px;
        color: #666;
      }

      .price-value {
        font-size: 14px;
        color: #1e88e5;
      }

      &.active {
        .price-value {
          font-weight: 500;
        }
      }
    }
  }
}
.duration-section.disabled,
.input-section.disabled {
  opacity: 0.6;
  pointer-events: none;
}

.duration-tab.disabled {
  cursor: not-allowed;
  opacity: 0.5;
}

.input-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background-color: #f8f9fa;

  .input-label {
    font-size: 16px;
    color: #333;
  }

  .input-control {
    display: flex;
    align-items: center;
    .quantity-btn {
      background: #f2f3f4;
      color: #000;
      width: 30px;
      padding: 0;
      height: 30px;
      border: 0;
    }

    .el-input-number {
      width: 50px;

      .el-input__inner {
        text-align: center;
        padding: 0;
        border: 0;
      }
    }

    ::v-deep .el-button.is-circle {
      padding: 8px;
      border-color: #ddd;

      &:hover {
        border-color: #1e88e5;
        color: #1e88e5;
      }
    }
  }
}
.free-trial-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  background: #f0f9eb;
  border-radius: 4px;
  color: #67c23a;
  font-size: 13px;
  margin-top: 12px;

  i {
    margin-right: 6px;
  }
}
.total-section {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px;
  background-color: #f8f9fa;

  .total-label {
    font-size: 16px;
    color: #333;
  }

  .total-price {
    font-size: 28px;
    font-weight: bold;
    color: #333;
  }
}

.dialog-footer {
  display: flex;
  margin: 16px 0;
  border-radius: 8px;

  .cart-btn {
    width: 56px;
    height: 48px;
    background: #e3f2fd;
    display: flex;
    align-items: center;
    justify-content: center;
    .cart-btn-icon {
      width: 32px;
      height: 32px;
      object-fit: contain;
    }

    &:hover {
      background: #bbdefb;
    }
  }

  .subscribe-btn {
    height: 48px;
    width: calc(100% - 60px);
    font-size: 16px;
    background: #1e88e5;
    border: none;

    &:hover {
      background: #1976d2;
    }
  }
  .subscribe-btn.full-width {
    width: 100%;
  }
}

.agreement-section {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 12px;
  color: #999;

  .agreement-text {
    line-height: 1.5;

    a {
      color: #1e88e5;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }
}
.agreement-dialog {
  z-index: 2001 !important;
  pointer-events: auto;
  // flex 布局：内容区自适应滚动，footer 固定在弹框底部
  display: flex;
  flex-direction: column;
  max-height: 80vh;

  .el-dialog__header {
    flex-shrink: 0;
    padding: 15px 20px 10px;
  }

  // 右上角关闭按钮美化
  .el-dialog__headerbtn {
    top: 14px;
    right: 14px;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: #f2f3f5;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background 0.2s;

    &:hover {
      background: #e4e7ed;

      .el-dialog__close {
        color: #333;
      }
    }

    .el-dialog__close {
      font-size: 14px;
      color: #666;
    }
  }

  .el-dialog__body {
    flex: 1;
    min-height: 0;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 0 20px;
  }

  .el-dialog__footer {
    flex-shrink: 0;
    padding: 14px 20px;
    text-align: center;
    border-top: 1px solid #eee;
    background: #fff;

    .el-button {
      min-width: 120px;
      height: 38px;
      border-radius: 19px;
    }
  }
}

.agreement-content {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 10px 12px;
  line-height: 1.7;
}
.agreement-content h3 {
  margin: 16px 0 8px;
  color: #333;
}
.agreement-content p {
  margin: 8px 0;
  text-indent: 2em;
}
</style>
